import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@dexio/common';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private readonly configs: AppConfigService, private readonly http: HttpClient) { }

  send(message: {to: string, cc: string, bcc: string, subject: string, body: string}, attachment: File|null) {
    const formData = new FormData();
    formData.append('to', message.to);
    formData.append('cc', message.cc);
    formData.append('bcc', message.bcc);
    formData.append('subject', message.subject);
    formData.append('body', message.body);
    if (attachment != null) { formData.append('attachment', attachment, attachment?.name); }
    
    return this.http
      .post(`${this.configs.get().apiUrl}/admin/email`, formData);
  }
}
